import Vue from "vue";
import gsap from "gsap";

Vue.prototype.$gsap = gsap;

Vue.use(Vue.prototype.$gsap);
